// 🔧 Dynamic API base URL detection
const getApiBaseUrl = () => {
  // 1. Check environment variable first
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  
  // 2. Try to auto-detect backend port (useful for development)
  const currentHost = window.location.hostname;
  const isLocalhost = currentHost === 'localhost' || currentHost === '127.0.0.1';
  
  if (isLocalhost) {
    // In development, assume backend runs on port 5001
    return `http://${currentHost}:5001`;
  }
  
  // 3. Default fallback for production or unknown environments
  return process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5001';
};

// Configuration for different environments - Backend API Only
const config = {
  development: {
    // Backend API only - connect to local Express server with dynamic base URL
    apiUrl: process.env.REACT_APP_API_URL || `${getApiBaseUrl()}/api`,
    financesApiUrl: process.env.REACT_APP_FINANCES_API_URL || `${getApiBaseUrl()}/api/finances`,
    calendarApiUrl: process.env.REACT_APP_CALENDAR_API_URL || `${getApiBaseUrl()}/api/calendar`,
    documentsApiUrl: process.env.REACT_APP_DOCUMENTS_API_URL || `${getApiBaseUrl()}/api/documents`,
    suppliersApiUrl: process.env.REACT_APP_SUPPLIERS_API_URL || `${getApiBaseUrl()}/api`,
    reportsApiUrl: process.env.REACT_APP_REPORTS_API_URL || `${getApiBaseUrl()}/api/rapports`,
    // 🔑 LICENSING API - Centralized INVOIT Licensing System
    licensingApiUrl: process.env.REACT_APP_LICENSING_API_URL || 'https://invoit-licensing-system.workers.dev',
    proxyUrl: '',
    assetsUrl: '',
    isElectron: false
  },
  production: {
    // Backend API only - for production deployment
    // Cloudflare Worker backend deployed at: https://travelit-backend.boufaamoundir.workers.dev
    apiUrl: process.env.REACT_APP_API_URL || 'https://travelit-backend.boufaamoundir.workers.dev/api',
    financesApiUrl: process.env.REACT_APP_FINANCES_API_URL || (process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/finances` : 'https://travelit-backend.boufaamoundir.workers.dev/api/finances'),
    calendarApiUrl: process.env.REACT_APP_CALENDAR_API_URL || (process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/calendar` : 'https://travelit-backend.boufaamoundir.workers.dev/api/calendar'),
    documentsApiUrl: process.env.REACT_APP_DOCUMENTS_API_URL || (process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/documents` : 'https://travelit-backend.boufaamoundir.workers.dev/api/documents'),
    suppliersApiUrl: process.env.REACT_APP_SUPPLIERS_API_URL || process.env.REACT_APP_API_URL || 'https://travelit-backend.boufaamoundir.workers.dev/api',
    reportsApiUrl: process.env.REACT_APP_REPORTS_API_URL || (process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/rapports` : 'https://travelit-backend.boufaamoundir.workers.dev/api/rapports'),
    // 🔑 LICENSING API - Centralized INVOIT Licensing System (Production)
    licensingApiUrl: process.env.REACT_APP_LICENSING_API_URL || 'https://invoit-licensing-system.workers.dev',
    proxyUrl: '',
    assetsUrl: '',
    isElectron: false
  },
  electron: {
    // Electron specific config - will be dynamically set at runtime
    apiUrl: '',
    financesApiUrl: '',
    calendarApiUrl: '',
    documentsApiUrl: '',
    suppliersApiUrl: '',
    reportsApiUrl: '',
    // 🔑 LICENSING API - Always use production URL for Electron
    licensingApiUrl: 'https://invoit-licensing-system.workers.dev',
    proxyUrl: '',
    assetsUrl: '',
    isElectron: true
  }
};

// Check if running in Electron environment
const isElectron = window && (window.electronAPI || window.__ELECTRON_CONFIG__);

// Force API mode for all environments
const forceApiMode = true;

// Determine current environment
const env = isElectron ? 'electron' : (process.env.NODE_ENV || 'development');

// Get config for current environment
const currentConfig = config[env];

// For Electron, set API URLs from the preload script
if (isElectron) {
  // Try both possible electron config objects
  const electronConfig = window.__ELECTRON_CONFIG__ || window.electronAPI || {};
  
  // 🔥 CRITICAL FIX: In Electron, backend always runs on localhost:5001
  // This ensures the embedded backend inside the EXE is accessible
  const baseUrl = electronConfig.apiBaseUrl || 'http://localhost:5001';
  
  // Set all API URLs
  currentConfig.apiUrl = `${baseUrl}/api`;
  currentConfig.financesApiUrl = `${baseUrl}/api/finances`;
  currentConfig.calendarApiUrl = `${baseUrl}/api/calendar`;
  currentConfig.documentsApiUrl = `${baseUrl}/api/documents`;
  currentConfig.suppliersApiUrl = `${baseUrl}/api`;
  currentConfig.reportsApiUrl = `${baseUrl}/api/rapports`;
  // 🔑 LICENSING API - Keep production URL for Electron
  // currentConfig.licensingApiUrl remains as set above (production URL)
  
  // Dispatch event for components to know config is ready
  window.dispatchEvent(new CustomEvent('api-config-ready'));
  
  console.log('🎯 Electron Mode: Backend embedded at', baseUrl);
  console.log('📡 API Configuration:', currentConfig);
}

// Export the configuration for the current environment
export default currentConfig;